import { trigger, state, style, animate, transition } from '@angular/animations';

/* SlideMenu Animation */ 

export const slideMenu = trigger('slideMenu', [
    state('false', style({
      transform: 'translateX(-250px)'
    })),
    state('true', style({
      transform: 'translateX(0)'
    })),
    transition('true <=> false', animate('400ms ease-in-out'))
  ])

  /* ScaleIn Animation */ 

  export const scaleIn = trigger('scaleIn', [
    transition('void => *', [
        style({ transform: 'scale(1.2)', opacity: 0 }),
        animate('.45s cubic-bezier(.3,.01,.27,.99)', style({ transform: 'scale(1)', opacity: 1 })),
    ]),
    transition('* => void', [
        style({ transform: 'scale(1)', opacity: 1 }),
        animate('.3s cubic-bezier(.3,.01,.27,.99)', style({ transform: 'scale(.8)', opacity: 0 })),
    ])
]);

/* Modal Animation */ 

export const modal = trigger('modal', [
  transition('void => *', [
      style({ transform: 'translateY(100%)' }),
      animate('1s cubic-bezier(.8,-0.48,.26,1.52)', style({ transform: 'translateY(0px)', opacity: 1 })),
  ]),
  transition('* => void', [
      style({ transform: 'translateY(0px)', opacity: 1 }),
      animate('1s cubic-bezier(.75,-0.48,.26,1.52)', style({ transform: 'translateY(100px)', opacity: 0 })),
  ])
]);

/* SlideIn Animation */ 

export const slideIn =
trigger('slideIn', [
    transition('void => *', [
        style({transform: 'scale(1)', opacity: 0}), 
        animate(500)
    ]),
    transition('* => void', [
        style({transform: 'scale(1)', opacity: 0.5}),
        animate(900)
    ])
])

/* FadeInOut Animation */ 

export const fadeInOut =
    trigger('fadeInOut', [
        state('off', style({
            display: 'none',
            opacity: 0
        })),
        state('on', style({
            opacity: 1
        })),
        transition('off => on', animate('.5s 100ms ease-in')),
        transition('on => off', animate('.3s 100ms ease-out'))
    ]);